/* eslint-disable */

export default {
  name: "createUser",
  setUser: (variables) => {
    variables.input.email = "{{email}}"
    return variables
  },
  data: /* GraphQL */ `
    mutation CreateUser($input: createUserInput!) {
      createUser(input: $input) {
        _id
      }
    }
  `,
}
